<template>
  <div class="p-4 bg-gray-100 min-h-screen">
    <Loader v-if="loading" />
    <Card class="shadow-2 surface-card border-round p-4 sm:p-6 lg:p-4">
      <template v-slot:title>
        <div class="text-2xl font-bold text-gray-800 flex align-items-center">
          <i class="pi pi-user-plus mr-2 text-primary"></i>
          Crea Utente
        </div>
      </template>

      <template v-slot:content>
        <div class="p-fluid">
          <div class="formgrid grid gap-3">
            <div class="col-12">
              <h4 class="text-lg font-semibold text-primary mb-3">Dati Anagrafici Utente</h4>
            </div>

            <div class="field col-12 md:col-6">
              <span class="p-float-label">
                <InputText id="cognome" v-model="utente.cognome" :class="{'p-invalid': validationErrors.cognome && submitted}"
                  @input="(val) => utente.cognome = utente.cognome.toUpperCase()" @change="onChangeInput($event, 'cognome')" />
                <label for="cognome">Cognome</label>
              </span>
              <small v-show="validationErrors.cognome && submitted" class="p-error">Campo richiesto.</small>
            </div>
            <div class="field col-12 md:col-6">
              <span class="p-float-label">
                <InputText id="nome" v-model="utente.nome" :class="{'p-invalid': validationErrors.nome && submitted}"
                  @input="(val) => utente.nome = utente.nome.toUpperCase()" @change="onChangeInput($event, 'nome')" />
                <label for="nome">Nome</label>
              </span>
              <small v-show="validationErrors.nome && submitted" class="p-error">Campo richiesto.</small>
            </div>

            <div class="field col-12 md:col-6">
              <span class="p-float-label">
                <InputMask id="mobile" mask="999-999999?9" v-model="utente.cellulare" :class="{'p-invalid': validationErrors.cellulare && submitted}"
                  @change="onChangeInput($event, 'cellulare')" />
                <label for="mobile">Cellulare</label>
              </span>
              <small v-show="validationErrors.cellulare && submitted" class="p-error">Campo richiesto.</small>
            </div>
            <div class="field col-12 md:col-6">
              <span class="p-float-label">
                <InputText id="email" v-model="utente.email" :class="{'p-invalid': (validationErrors.email || validationErrors.isEmail) && submitted}"
                  @input="(val) => utente.email = utente.email.toLowerCase()" @change="onChangeInput($event, 'email')" />
                <label for="email">Email</label>
              </span>
              <small v-show="validationErrors.email && submitted" class="p-error">Campo richiesto.</small>
              <small v-show="validationErrors.isEmail && submitted" class="p-error">Formato email errato.</small>
            </div>

            <div class="field col-12 md:col-6">
              <span class="p-float-label">
                <InputMask mask="aaaaaa99a99a999a" id="codfis" v-model="utente.codfis" :class="{'p-invalid': validationErrors.codfis && submitted}"
                  @input="(val) => utente.codfis = utente.codfis.toLowerCase()" @change="onChangeInput($event, 'codfis')" />
                <label for="codfis">Codice Fiscale</label>
              </span>
              <small v-show="validationErrors.codfis && submitted" class="p-error">Campo richiesto.</small>
            </div>
            <div class="field col-12 md:col-6">
              <span class="p-float-label">
                <InputText id="indirizzo" v-model="utente.indirizzo" :class="{'p-invalid': validationErrors.indirizzo && submitted}"
                  @input="(val) => utente.indirizzo = utente.indirizzo.toUpperCase()" @change="onChangeInput($event, 'indirizzo')" />
                <label for="indirizzo">Indirizzo</label>
              </span>
              <small v-show="validationErrors.indirizzo && submitted" class="p-error">Campo richiesto.</small>
            </div>

            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <InputText id="luogodinascita" v-model="utente.luogodinascita" :class="{'p-invalid': validationErrors.luogodinascita && submitted}"
                  @change="onChangeInput($event, 'luogodinascita')" />
                <label for="luogodinascita">Luogo di nascita</label>
              </span>
              <small v-show="validationErrors.luogodinascita && submitted" class="p-error">Campo richiesto.</small>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <Calendar v-model="utente.datadinascita" dateFormat="dd/mm/yy" :showIcon="true"
                  :yearNavigator="true" :monthNavigator="true" :yearRange="'1900:' + new Date().getFullYear()"
                  @change="onChangeInput($event, 'datadinascita')" :class="{'p-invalid': validationErrors.datadinascita && submitted}" />
                <label>Data di nascita</label>
              </span>
              <small v-show="validationErrors.datadinascita && submitted" class="p-error">Campo richiesto.</small>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <Dropdown v-model="utente.comune" :options="cities" :filter="true" optionLabel="name" optionValue="id"
                  :virtualScrollerOptions="{ itemSize: 38 }" @change="onChangeInput($event, 'comune')"
                  :class="{'p-invalid': validationErrors.comune && submitted}" />
                <label>Comune</label>
              </span>
              <small v-show="validationErrors.comune && submitted" class="p-error">Campo richiesto.</small>
            </div>

            <div class="col-12 mt-4 flex align-items-center">
              <Checkbox v-model="block_div_atleti" id="check_associa_Atleti" :binary="true" @click="viewDataTableAtleti" />
              <label for="check_associa_Atleti" class="ml-2">Crea Atleti</label>
            </div>
          </div>

          <div class="mt-5" id="container-atleti">
            <h4 class="text-lg font-semibold text-primary mb-3">Elenco Atleti</h4>
            <DataTable :value="atleti" editMode="cell" @cell-edit-complete="onCellEditComplete" class="p-datatable-sm">
              <template #empty>
                <div class="text-center p-3 text-sm text-gray-500">Nessun atleta inserito.</div>
              </template>
              <Column :exportable="false" style="width: 3rem">
                <template #body="{ data, index }">
                  <Button icon="pi pi-trash" class="p-button-danger p-button-sm p-button-text" @click="deleteRow(data, index)" v-tooltip.top="'Rimuovi atleta'" />
                </template>
              </Column>
              <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header">
                 <template #body="{ data, index }">
                    <div class="flex flex-column">
                      <div>
                        <span v-if="col.field === 'birth'">
                          {{ data[col.field] ? moment(data[col.field]).format('DD/MM/YYYY') : '' }}
                        </span>

                        <span v-else-if="col.field === 'comune'">
                          {{ cities.find(c => c.id === data[col.field])?.name || '' }}
                        </span>

                        <span v-else>
                          {{ data[col.field] || 'Inserisci...' }}
                        </span>
                      </div>

                      <div
                        v-show="validationErrors[`${col.field}_${index}`]"
                        class="p-error mt-1"
                        style="font-size:11px"
                      >
                        Campo necessario
                      </div>
                    </div>
                  </template>

                  <template #editor="{ data, index }">
                    <div v-if="col.field === 'birth'">
                      <Calendar
                      v-model="data[col.field]"
                      dateFormat="dd/mm/yy"
                      :showIcon="true"
                      :showOnFocus="false"
                      :maxDate="maxDate"
                      :yearNavigator="true"
                      :monthNavigator="true"
                      :yearRange="'1900:' + new Date().getFullYear()"
                      @change="onChangeInput($event, `${col.field}_${index}`)"
                      class="w-full"
                    />
                    </div>

                    <div v-else-if="col.field === 'gender'">
                      <div class="flex flex-column gap-3">
                        <div
                          v-for="gender in genders"
                          :key="gender.key"
                          class="flex align-items-center"
                        >
                          <RadioButton
                            v-model="data[col.field]"
                            :id="`gender_${gender.key}_${index}`"
                            name="dynamic"
                            :value="gender.name"
                          />
                          <label :for="`gender_${gender.key}_${index}`" class="ml-2">
                            {{ gender.name }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div v-else-if="col.field === 'cf'">
                      <InputMask
                        v-model="data[col.field]"
                        mask="aaaaaa99a99a999a"
                        autofocus
                        class="w-full text_toupper"
                        @change="onChangeInput($event, `${col.field}_${index}`)"
                      />
                    </div>

                    <div v-else-if="col.field === 'comune'">
                      <Dropdown
                        v-model="data[col.field]"
                        :options="cities"
                        :filter="true"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Seleziona comune"
                        class="inputfield w-full"
                        :class="{'p-invalid': validationErrors.comune && submitted}"
                        :virtualScrollerOptions="{ itemSize: 38 }"
                        @change="onChangeInput($event, `${col.field}_${index}`)"
                      />
                    </div>

                    <div v-else>
                      <InputText
                        v-model="data[col.field]"
                        autofocus
                        class="w-full"
                        @change="onChangeInput($event, `${col.field}_${index}`)"
                      />
                    </div>
                  </template>
              </Column>
            </DataTable>
            <div class="flex justify-content-end mt-3">
              <Button icon="pi pi-plus" class="p-button-success p-button-rounded" @click="addRow" v-tooltip.top="'Aggiungi Atleta'" />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="flex justify-content-end pt-5">
          <Button label="Salva" icon="pi pi-check" class="p-button-primary" @click="sendDataNewUser" />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import moment from 'moment'
import { useToast } from 'primevue/usetoast';

export default {
  components: {
    Loader,
  },
  
  setup () { 
    
    const self = getCurrentInstance();
    const toast = useToast();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const submitted = ref(false)
    const loading = ref(false)
    const utente = ref({})
    const lifeTime = 3000
    const validationErrors = ref({})
    const atleti = ref([])
    const columns = [
    { field: 'surname', header: 'Cognome' },
    { field: 'name', header: 'Nome' },
    { field: 'birth', header: 'Data di nascita' },
    { field: 'gender', header: 'Sesso' },
    { field: 'comune', header: 'Città' },
    { field: 'indirizzo', header: 'Indirizzo' },
    { field: 'luogodinascita', header: 'Luogo di Nascita' },
    { field: 'cf', header: 'Codice fiscale' }
    ];
    const genders = [
    {key:0, name:'Maschio'},
    {key:1, name:'Femmina'}
    ]
    const cities = ref([])
    const maxDate = ref();
    const today = new Date();
    const block_div_atleti = ref(true)
 
    
    const onSelectedMobile = (evt) => {
      utente.value.cellulare = evt.target.value;
      delete validationErrors.value['cellulare'];
    }
    const addRow = () => {
      let newRow = columns.reduce((obj, column) => {
        obj[column.field] = '';
        return obj;
      }, {});
      newRow.gender = 'Maschio'
      newRow.surname = utente.value.cognome ?? ''
      newRow.indirizzo = utente.value.indirizzo ?? ''
      newRow.comune =cities.value.find(city => city.id === utente.value.comune )?.name ?? ''
      atleti.value.push(newRow)   
    }
    const onCellEditComplete = (event) => {
      let { field, index } = event;
      console.log(field);
      if (field != 'gender' && field != 'birth' && field != 'comune') {
        atleti.value[index][field] = atleti.value[index][field].toUpperCase()
      }
    };
    const deleteRow = (row, index) => {
      atleti.value.splice(index, 1);
      validationErrors.value = []
    }
    const getComuni = async () => {
      await service.getComuni()
      .then((res) => {
        cities.value = res.items
      })
    }
    const onChangeInput = (evt, prop) => {
      let value
      switch (prop) {
        case 'comune':
        value = evt.value
        break;
        
        default:
        value = evt.target.value
        break;
      }
      if (value == '' || value == null) {
        validationErrors.value[prop] = true
      }else{
        delete validationErrors.value[prop]
      }
    }
    
    const viewDataTableAtleti = () => {
      let div_atleti = document.getElementById('container-atleti')
      block_div_atleti.value = !block_div_atleti.value
      let style = block_div_atleti.value ? 'block' : 'none'
      div_atleti.style.display = style
      if (!block_div_atleti.value) {
        atleti.value = []
      }
    }
    
    const validateForm = () => {
      // Validazione Utente
      let validate_properties = [
      'nome',
      'cognome',
      'email',
      //'cellulare',
      //'indirizzo',
      //'comune'
      ]
      let validate_properties_atleti = [
      'name',
      'surname',
      'birth'
      //'email',
      //'cellulare',
      //'indirizzo',
      //'comune'
      ]
      let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      
      validate_properties.forEach( prop => {
        if (utente.value[prop] == '' || utente.value[prop] == null) {
          validationErrors.value[prop] = true
        } else {
          delete validationErrors.value[prop];
          if (prop == 'email') {
            if (regex_email.test(utente.value[prop])) {
              delete validationErrors.value.isEmail;
            } else {
              validationErrors.value.isEmail = true
            }
          }
        }
      })
      // Fine Validazione Utente
      
    if (block_div_atleti.value) {
      if (atleti.value.length == 0) {
        toast.add({ severity: 'warn', summary: 'Errore', detail: `Nessun atleta inserito`, life: lifeTime });
        return false;
      } else {
        atleti.value.forEach((atleta, indice) => {
          validate_properties_atleti.forEach(prop => {
            const key = `${prop}_${indice}`;

            if (atleta[prop] == '' || atleta[prop] == null) {
              validationErrors.value[key] = true;
            } else {
              delete validationErrors.value[key];

              if (prop == 'email') {
                if (regex_email.test(atleta[prop])) {
                  delete validationErrors.value[`isEmail_${indice}`];
                } else {
                  validationErrors.value[`isEmail_${indice}`] = true;
                }
              }
            }
          });
        });
      }
    }
        // Fine Validazione Atleti
      return !Object.keys(validationErrors.value).length;
    }
    const setDataTime = (el) => {
      let giorno = el.getDate() 
      let mese = el.getMonth()+1
      mese = mese.toString().padStart(2,'0')
      let anno = el.getFullYear() 
      el = `${anno}-${mese}-${giorno}`
      return el
    } 
    
    
    const sendDataNewUser = async () => {
      submitted.value = true;
      validationErrors.value = []
      console.log("sendDataNewUser")
      if(validateForm()){
        loading.value = true
        let fd = new FormData();
        if (utente.value.datadinascita)
          utente.value.datadinascita = setDataTime(utente.value.datadinascita)
        atleti.value.forEach((atleta, indice) => {
          if (atleta.birth)
            atleta.birth = setDataTime(atleta.birth)
          //if (atleta.comune)
            //atleta.comune = cities.value.find(city => city.name === atleta.comune)?.id ?? ''
        })
        fd.append('utente', JSON.stringify(utente.value));
        fd.append('atleti', JSON.stringify(atleti.value));
        
        service.sendDataNewUser(fd)
        .then((res) => {
          let severity = res.item.error ? 'warn' : 'success'
          let summary = res.item.error ? 'Attenzione' : 'Successo'
          let detail = res.item.response
          
          toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});
        }).finally(() => {
          initData()
          loading.value = false
        })
      }
    else{
        toast.add({severity:'warn', summary: 'Attenzione', detail:`Ci sono dei dati mancanti`});
      }
    }
    
    const initData = () => {
      // restart var
      utente.value = {}
      atleti.value = []
      block_div_atleti.value = true
      // setMaxData
      const currentYear = today.getFullYear();
      const previousYear = currentYear - 1;
      maxDate.value = new Date(previousYear, today.getMonth(), today.getDate());
    }
    
    onMounted(() => { 
      initData()
      getComuni()
    })
    
    return {
      loading,
      submitted,
      utente,
      validationErrors,
      onSelectedMobile,
      atleti,
      cities,
      columns,
      addRow,
      onCellEditComplete,
      genders,
      moment,
      deleteRow,
      maxDate,
      viewDataTableAtleti,
      block_div_atleti,
      sendDataNewUser,
      onChangeInput,
    }
  },
}
</script>

<style>
.text_toupper{
  text-transform: uppercase;
} 
</style>
<style scoped>
#container-atleti{
  display: block;
}
.layout-main-container{
  width: fit-content !important;
}
.btn-error-filter{
  width: 200px;
}
</style>
